import Masonry from "masonry-layout";
("use strict");

const grid = document.querySelector(".grid");


const mediaQuery = window.matchMedia("(min-width: 991px)");
// const mediaQuery2 = window.matchMedia("(min-width: 1025px)");
let msnry;

function initMasonry() {
    // let gutter = 100;
    // if (mediaQuery2.matches) {
    //     gutter = 200;
    // }
    if (mediaQuery.matches) {
        grid.classList.remove('masonry-disabled');
        msnry = new Masonry(grid, {
            itemSelector: ".grid-item",
            gutter: 200,
        });
    } else {
        grid.classList.add('masonry-disabled');
        if (msnry) {
            msnry.destroy();
        }
    }
}

initMasonry();

window.addEventListener("resize", function() {
    initMasonry();
});


